// import $ from 'jquery'

// window.localStorage.setItem('logoutPathUrl', $('html').data('logout-path-url'))
// !window.sessionStorage.getItem('urlFragment') && window.sessionStorage.setItem('urlFragment', $('html').data('url-fragment') || '')
// if ($('html').data('url-fragment') ) {
//   window.location.hash = "#" + ( window.sessionStorage.getItem('urlFragment') || '' )
//   if (window.location.pathname !== window.sessionStorage.getItem('urlFragment')) {
//     window.location.pathname ='/'
//   }
// }

export default {
  //   applicationDisplayName:  $('html').data('referer-name') === 'workstation' ? 'CME Workstation' : 'CME One',

  useHomeTab: false,

  socketReconnected: false,

  socketDisconnected: false,

  socketErrorIncrement: 0,

  vpView: false,

  validVendors: ["kpler", "w3schools"],

  instrumentIDs: {
    kpler: "XNYM-LNG", // LNG Futures
    w3schools: "XNYM-LNG", // LNG Futures
  },

  // OnePass enabled users in user support roles
  allowedSupportGroups: ["cmegFirmsoft", "hostedExchange"],

  stateClasses: {
    hidden: "is-hidden",
    active: "is-active",
    loading: "is-loading",
  },

  //   firmsoft: {
  //     workspaceName: 'FirmSoftTab',
  //     workspaceVisitedMapKey: 'visitedFS',
  //     cmegDisabledCards: ['NIGHTLY REPORTS'],
  //     hostedExhangeDisabledCards: ['MASS QUOTE CANCEL', 'CANCELLATION HISTORY', 'NIGHTLY REPORTS'],
  //     searchCriteria: {},
  //     nightlyReportsEnabled: $('html').data('nightly-reports'),
  //     nightlyReportsLimit: 10,
  //     firmsoftBrokerTecEnabled: $('html').data('firmsoft-brokertec-enabled'),
  //     firmsoftEbsEnabled: $('html').data('firmsoft-ebs-enabled'),
  //     defaultTableRowLimit: 10,
  //     fullscreenTableRowLimit: 100,
  //     multiSelectCaseMap: {
  //       All: 'All',
  //       gtc: 'GTC',
  //       gtd: 'GTD',
  //       fak: 'FaK',
  //       day: 'Day',
  //       fok: 'FoK',
  //       outright: 'Outright',
  //       leg: 'Leg',
  //       spread: 'Spread',
  //       gfs: 'GFS'
  //     },
  //     relativeDatesMap: {
  //       '-3': '3 Days Forward',
  //       '-2': '2 Days Forward',
  //       '-1': '1 Day Forward',
  //       0: 'Today',
  //       1: '1 Day Ago',
  //       2: '2 Days Ago',
  //       3: '3 Days Ago',
  //       4: '4 Days Ago',
  //       5: '5 Days Ago',
  //       6: '6 Days Ago',
  //       7: '7 Days Ago'
  //     },
  //     customDateOptions: ['All', 'Custom', 'Current Week'],
  //     hideSearchFormCriteria: {
  //       save: true,
  //       edit: true,
  //       search: false
  //     }
  //   },

  cmed: {
    workspaceName: "TraderCMED",
    workspaceVisitedMapKey: "visitedCMED",
    defaultCMEDAccount: undefined,
    maxMarketActivityResults: 100,
  },

  // Hash map of desired labels used in search against current object keys
  searchLabels: {
    firm: "Firm",
    firms: "Firm",
    sessionIds: "Session ID",
    sessionId: "Session ID",
    accounts: "Account",
    senderSubIds: "Operator ID",
    orderStatus: "Order Status",
    timeInForces: "TIF",
    timeInForce: "TIF",
    validityTypes: "TIF",
    executionTypes: "Execution Types",
    clientOrderId: "Client Order ID",
    clientOrderIds: "Client Order ID",
    productId: "Contract",
    duration: "Duration",
    side: "Side",
    price: "Price",
    micCodes: "Exchange",
    tag50sCheck: "Return Operator IDs",
    showTag50: "Show Operator IDs",
    sessionDay: "Trading Day",
    sessionDate: "Trading Day",
    priceFormat: "Price Format",
    fillPrice: "Fill Price",
    orderPrice: "Order Price",
    exchangeIds: "Exchange",
    productIds: "Contract",
    excludeSpreads: "Exclude Spreads",
    quoteTypes: "Include Mass Quote",
    fillDisplayPrice: "Fill Display Price",
    orderDisplayPrice: "Order Display Price",
    limitPrice: "Limit Price",
    favouritesName: "Favorite",
    favouritesId: "Favorite ID",
    cancelReasons: "Cancelation Reason",
    marketSegmentIds: "Market Segment Id",
    startTime: "Start Date/Time",
    endTime: "End Date/Time",
    queryName: "Query-Name",
  },

  isMobile: false,

  isTouch: false,

  isSmallScreen: false,

  isIndexedDB: false,

  isVisible: true,

  // Storing a map of each server action.
  socket: {
    actions: {
      GET_PREFERENCES: "getpreference",
      FULL_NAME: "getFullName",
      SAVE_PREFERENCES: "savepreferences",
      FS_GET_SEARCH_DATA: "searchCriteria",
      FS_GET_SEARCH_RESULTS: "order/search",
      FS_MASS_QUOTE_CANCEL: "massQuote/cancel",
      FS_ORDER_CANCEL: "order/cancel",
      FS_ORDER_CANCEL_ALL: "order/cancelAll",
      FS_GET_AGGFILLS_SEARCH_RESULTS: "netposition/search",
      FS_GET_TRADEFILLS_SEARCH_RESULTS: "trade/search",
      FS_GET_MASS_QUOTE_CANCEL_DATA: "audit/massQuoteCancel",
      FS_GET_SEARCH_FAVOURITES: "favourite/search",
      FS_GET_FAVOURITE_SAVE: "favourite/save",
      FS_GET_ORDER_CANCEL_DATA: "audit/orderCancel",
      FS_GET_ORDER_DETAILS: "order/details",
      FS_GET_FAVOURITE_UPDATE: "favourite/edit",
      FS_GET_FAVOURITE_DELETE: "favourite/delete",
      FS_GET_NIGHTLY_REPORTS: "nightlyReports/search",
      FS_CREATE_NIGHTLY_REPORTS: "nightlyReports/create",
      FS_UPDATE_NIGHTLY_REPORTS: "nightlyReports/pause",
      FS_REMOVE_NIGHTLY_REPORTS: "nightlyReports/remove",
      CMED_LOGON: "cmed/getlogonresponse",
      CMED_LOGON_SUCCESS_RESPONSE: "cmed/getlogonresponse/success",
      CMED_LOGON_SELECTION_NEEDED_RESPONSE:
        "cmed/getlogonresponse/loginselectionneeded",
      CMED_LOGON_USER_SELECTED: "cmed/logon/userselected",
      CMED_LOGOFF: "cmed/logoff",
      CMED_ORDERS_SUBSCRIBE: "cmed/orders/subscribe",
      CMED_ORDERS_UNSUBSCRIBE: "cmed/orders/unsubscribe",
      CMED_ORDER_CRITERIA: "cmed/order/criteria",
      CMED_TRADING_ACCOUNTS: "cmed/tradingaccounts",
      CMED_ITEM_PRICES: "cmed/item/prices",
      CMED_ORDER_ENTRY: "cmed/order/entry",
      CMED_ORDER_AMEND: "cmed/order/amend",
      CMED_ORDER_AGGRESSSION: "cmed/order/aggression",
      CMED_CONNECTION: "cmed/connection",
      CMED_PRODUCTS: "cmed/instruments",
      CMED_STRATEGIES: "cmed/strategies",
      CMED_PERIODS_INSTRUMENT_ACTIONS: "cmed/periods",
      CMED_GET_CONTRACTS: "cmed/contracts",
      CMED_GET_CONTRACTS_BY_ITEM_ID: "cmed/contracts/id",
      CMED_GET_STRIKES: "cmed/strikes",
      CMED_ADD_CONTRACTS: "cmed/addContractToGrid",
      CMED_ADD_OPTION_CONTRACTS: "cmed/addOptionContractToGrid",
      CMED_REMOVE_CONTRACTS: "cmed/removeContractFromGrid",
      CMED_ORDERS_SUBSCRIBE_VENDOR: {
        kpler: "cmed/addContractsToGrid",
        w3schools: "cmed/addContractsToGrid",
      },
      CMED_MARKET_ACTIVITY: "cmed/marketActivity",
      CMED_INSTRUMENT_CATEGORIES: "cmed/getInstrumentCategories",
      CMED_ORDER_ACTIVATE: "cmed/selectedorder/activate",
      CMED_ORDER_CANCEL: "cmed/selectedorder/cancel",
      CMED_ORDER_HOLD: "cmed/selectedorder/hold",
      CMED_ORDER_TICKUP: "cmed/selectedorder/tickup",
      CMED_ORDER_TICKDOWN: "cmed/selectedorder/tickdown",
      CMED_ORDER_HOLDALL: "cmed/orders/hold",
      CMED_ORDER_CANCELALL: "cmed/orders/cancel",
      CMED_CONTRACT_MD_UNSUBSCRIBE: "cmed/contractmarketdata/unsubscribe",
      SERVICE_STATUS: "serviceStatus",
    },
    alertActions: {
      FirmSoftTab: "alerts/firmsoft",
    },
    subscriptions: {
      ORDER_CANCELLATIONS: "/user/queue/cancelledOrders",
      CMED_USER_UPDATES: "/user/queue/accountUpdate",
      CMED_ORDERS_SUBSCRIBE: "/user/queue/orders",
      CMED_MARKET_ACTIVITY: "/user/queue/marketActivity",
      ALERT_STATUS: "/user/queue/alerts/status",
    },
    topics: {
      FIRMSOFT_ALERTS: "/topic/alerts/riskMgt",
    },
    channels: {
      TRADING: "/app/trading",
      RISK: "/app/riskMgt",
      CORE: "/app/core",
    },
  },

  messageConstantPrefix: "message_",

  confirmMessages: {
    massQuoteCancel: {
      CONFIRM_CANCELLATION:
        "Are you sure you want to proceed " +
        "with issuing a cancelation for the " +
        "following firms and sessions?",
      CANCELLATION_COMPLETE:
        "Cancelation requested for the following firms and sessions:",
    },
    lastOrderCardWithDetails: {
      CONFIRM_REMOVAL:
        "You have active Order Detail cards. Closing this Orders card will also " +
        "remove those cards. Do you wish to proceed?",
    },
  },

  errorMessages: {
    inactivity: "Your session has expired due to inactivity.",
  },

  infoMessages: {
    impersonatePrompt:
      "As a support user, please impersonate another user to view Firms & Sessions",
    firmCancellationPermission:
      "No entitled Firms with cancelation permission found.",
  },

  serviceMessages: {
    INSTANCE_DOWN:
      "Your connection has dropped. Please log out and log back in to continue.",
    INSTANCE_UP:
      "Your connection has returned. Please log out and log back in to continue.",
    SERVICE_DOWN: "Service currently unavailable. Please try again later.",
    SERVICE_UP:
      "Your connection to the service has returned. Please log out and log back in to continue.",
  },

  serviceConstants: {
    stateChange: "SERVICE_STATE_CHANGE",
    downStates: ["INSTANCE_DOWN", "SERVICE_DOWN"],
    edgeFailure: "EDGE_FAILURE",
  },

  dateFormats: {
    dateFormatAPI: "YYYY-MM-DD",
    isoDateFormat: "YYYY-MM-DD",
    dateFormatUI: "DD MMM YYYY",
    dateFormatShort: "MM/DD/YY",
  },

  dateTimeFormat: {
    dateTimeFormatAPI: "MM/DD/YYYY HH:mm:ss",
    timeFormat: "HH:mm:ss",
  },

  entitlementRequests: {
    actions: ["searchcriteria"],
  },

  // A list of endpoints that will be validated and handled at request level.
  validatedEndpoints: ["order/search", "trade/search", "netposition/search"],

  xhrReadyStates: {
    NOT_INIT: 0,
    CONNECTED: 1,
    REQUEST_RECEIVED: 2,
    PROCESSING: 3,
    COMPLETED: 4,
  },

  // From end of array ie [array.length - threshold]
  cmedTickThresholdUpper: 4,
  cmedTickThresholdLower: 4,

  //   isDevelopmentEnvironment: $('html').data('environment') === 'dev',
  //   isQAEnvironment: $('html').data('environment') === 'qa',
  //   isNREnvironment: $('html').data('environment') === 'nr',
  //   isProductionEnvironment: $('html').data('environment') === 'prod',
  //   isUpperProductionEnvironment: $('html').data('environment') === 'prod' || $('html').data('environment') === 'dr' || $('html').data('environment') === 'cert',

  //   isRefered: $('html').data('refered'),
  //   refererName: $('html').data('referer-name'),
  //   isDeeplink: $('html').hasClass('is-deeplink'),
  //   isElectron: window.isElectron,
  //   isWorkstation: $('html').data('referer-name') === 'workstation',

  shouldResubscribeToServices: false,

  socketDebugDisabled: false,

  lastDisconnectEvent: null,

  lastDisconnectEventHourLimit: 3,

  localStorageKeys: {
    LAST_VISITED_DEEPLINK: "LAST_VISITED_DEEPLINK",
    LAST_DISCONNECT_EVENT: "LAST_DISCONNECT_EVENT",
  },
};
